import './App.css';
import { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, } from "react-router-dom";

import styled from "styled-components";
import Loader from './Loading';
import ListFonts from './pages/ListFonts';
import User from './utils/User';
import { Button, Drawer, Image, MantineProvider, Modal, Text, Title } from '@mantine/core';
import '@mantine/core/styles.css';
import FotoLogo from './assets/logo_fonts.png';
import ControlTrad from './assets/trad/ControlTrad';
import { Notifications } from '@mantine/notifications';
import { useDisclosure } from '@mantine/hooks';
import { IonApp } from '@ionic/react';
import { App as CapacitorApp } from '@capacitor/app';
import { IconExternalLink } from '@tabler/icons-react';

const HomePage = lazy(() => import('./pages/Home'));

const AppWrapper = styled.div`
width:100vw;
height: 100vh;
z-index: -1;
position: absolute;
`

const App  = () => {
  const [loading, setLoading] = useState(true);
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedTypes, setSelectedTypes] = useState({ 1: true, 2: true, 3: true });
  const [lang, setLang] = useState(User.getLang());
  const [ubi, setUbi] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [openedFirst, { toggle }] = useDisclosure(false);


  const handleResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight)
};

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (!canGoBack) {
        CapacitorApp.exitApp();
      } else {
        window.history.back();
      }
    });

    const timer = setTimeout(() => {
      open(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    ControlTrad.getLang(lang);
  }, [lang])


  useEffect(()=>{
    if(!loading){
      if(User.getFirstTime()){
          //toggle(true);
      }
    }
  },[loading])
  
  return (
    <IonApp>
      <MantineProvider 
        theme={{
          globalStyles:(theme) =>({
            'html, body' : {
              textSizeAdjust:"100%",
              WebkitTextSizeAdjust : "100%", 
            }
          }),
        }}
      >
        <AppWrapper id={"id_wrapper"}>
          <Router>
            {loading ? <Loader /> : (
              <Suspense fallback={<Loader />}>
                <Routes>
                  <Route path="*" element={<Navigate to="/" />} />
                  <Route path="/:fontid?" element={<HomePage lang={lang} setLang={setLang} ubi={ubi} setUbi={setUbi} selectedTypes={selectedTypes} setSelectedTypes={setSelectedTypes} />} />
                  <Route path="/list" element={<ListFonts lang={lang} setLang={setLang} />} />
                </Routes>
              </Suspense>
            )}
          </Router>

          <Drawer opened={opened} onClose={(e) => { close(e); setLoading(false); }} position="bottom" size="100%" >
            <div style={{ textAlign: "center", margin: "0 auto", height: "90vh", alignContent: 'center' }}>
              <Title order={2}>{ControlTrad.getTrad("startMessage1")}</Title>
              <Title order={1}>{ControlTrad.getTrad("startMessage2")}</Title>
              <Text>
                {ControlTrad.getTrad("startMessage3")}
              </Text>
              <Text>
                {ControlTrad.getTrad("startMessage4")}
              </Text>
              <Image w={height <= 475 ? "20%" :  width <= 450 ? "300px" : "375px"} m={"0 auto"} src={FotoLogo} alt="Logotip Fonts de Terrassa"/>
              <Button color={"#a36cab"} onClick={() => { close(false); setLoading(false) }}>
                {ControlTrad.getTrad("startMessage5")}
              </Button>
            </div>
          </Drawer>
          <Modal opened={openedFirst} onClose={(e)=>{toggle(e);}} centered>
            <p>Disfruteu de la versió de Android!</p>
            <Button>Descarrega't la versió app <IconExternalLink size={"14px"} style={{marginLeft:"4px"}}/></Button>
            <p>La versió en iPhone esta en desenvolupament</p>
          </Modal>
          <Notifications />
        </AppWrapper>
      </MantineProvider>
    </IonApp>
  );
};


export default App;
